import { Form, Input, Modal } from 'antd'

type AgendaFormValues = {
  title: string
  description: string
}

type EditableAgendaItem = {
  title: string
  description: string
}

type CreateAgendaModalProps = {
  open: boolean
  editingItem: EditableAgendaItem | null
  onCancel: () => void
  onSubmit: (values: AgendaFormValues) => Promise<void>
  form: ReturnType<typeof Form.useForm<AgendaFormValues>>[0]
  isLoading: boolean
}

export function CreateAgendaModal({
  open,
  editingItem,
  onCancel,
  onSubmit,
  form,
  isLoading,
}: CreateAgendaModalProps) {
  const handleOk = async () => {
    try {
      const values = await form.validateFields()
      await onSubmit(values)
    } catch {
      //
    }
  }

  return (
    <Modal
      title={editingItem ? 'Edit agenda item' : 'Add agenda item'}
      open={open}
      onCancel={onCancel}
      onOk={handleOk}
      okText={editingItem ? 'Save' : 'Add'}
      cancelText="Cancel"
      confirmLoading={isLoading}
      width={520}
      destroyOnClose
      styles={{
        body: { paddingTop: 24 },
      }}
    >
      <Form form={form} layout="vertical" size="large">
        <Form.Item
          name="title"
          label="Title"
          rules={[{ required: true, message: 'Enter a title' }]}
        >
          <Input placeholder="e.g. Monthly financial review" />
        </Form.Item>
        <Form.Item
          name="description"
          label="Description"
          rules={[{ required: true, message: 'Enter a description' }]}
        >
          <Input.TextArea
            rows={4}
            placeholder="What should the AI focus on for this topic?"
          />
        </Form.Item>
      </Form>
    </Modal>
  )
}
